import { Button, ButtonProps } from "@jugl-web/ui-kit";
import React from "react";

export const IdentifyContactDialogFooter: React.FC<{
  buttons: (Omit<ButtonProps, "ref"> & { text: string })[];
}> = ({ buttons }) => (
  <div className="flex h-[72px] shrink-0 items-center justify-end gap-4 border-0 border-t border-solid border-dark-100 px-6">
    {buttons.map(({ text, className, ...props }, idx) => (
      <Button {...props} className={className} key={+idx}>
        {text}
      </Button>
    ))}
  </div>
);
